import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-nine',
  templateUrl: './home-page-nine.component.html',
  styleUrls: ['./home-page-nine.component.scss']
})
export class HomePageNineComponent implements OnInit, OnDestroy {
  showSplash = true;
  isSplashClosing = false;
  showThankYou = false;

  private readonly splashDuration = 7000;
  private readonly splashExitDuration = 1600;
  private readonly splashStorageKey = 'homeNineSplashPlayed';

  private splashTimer: ReturnType<typeof setTimeout> | null = null;
  private splashCloseTimer: ReturnType<typeof setTimeout> | null = null;

  private readonly contextMenuHandler = (event: Event): void => {
    event.preventDefault();
  };

  private readonly copyHandler = (event: Event): void => {
    event.preventDefault();
  };

  constructor() {}

  ngOnInit(): void {
    this.initContentProtection();
    this.initSplash();
  }

  ngOnDestroy(): void {
    document.removeEventListener('contextmenu', this.contextMenuHandler);
    document.removeEventListener('copy', this.copyHandler);

    document.body.style.userSelect = '';
    (document.body.style as CSSStyleDeclaration).webkitUserSelect = '';
    document.body.style.overflow = '';

    if (this.splashTimer) {
      clearTimeout(this.splashTimer);
    }

    if (this.splashCloseTimer) {
      clearTimeout(this.splashCloseTimer);
    }
  }

  private initSplash(): void {
    const alreadyPlayed = sessionStorage.getItem(this.splashStorageKey) === 'true';

    if (alreadyPlayed) {
      this.showSplash = false;
      return;
    }

    this.showSplash = true;
    this.showThankYou = false;
    document.body.style.overflow = 'hidden';

    this.splashTimer = setTimeout(() => {
      this.closeSplash();
    }, this.splashDuration);
  }

  closeSplash(): void {
    if (!this.showSplash || this.isSplashClosing) {
      return;
    }

    this.showThankYou = true;
    this.isSplashClosing = true;

    this.splashCloseTimer = setTimeout(() => {
      this.showSplash = false;
      this.isSplashClosing = false;
      this.showThankYou = false;
      document.body.style.overflow = '';
      sessionStorage.setItem(this.splashStorageKey, 'true');
    }, this.splashExitDuration);
  }

  private initContentProtection(): void {
    document.addEventListener('contextmenu', this.contextMenuHandler);
    document.addEventListener('copy', this.copyHandler);

    document.body.style.userSelect = 'none';
    (document.body.style as CSSStyleDeclaration).webkitUserSelect = 'none';
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    const key = event.key.toLowerCase();

    if (event.ctrlKey && (key === 'c' || key === 'u' || key === 's')) {
      event.preventDefault();
    }
  }
}